import { render, staticRenderFns } from "./BlocoListarAtivasCertificao.vue?vue&type=template&id=b1059244&lang=pug"
import script from "./BlocoListarAtivasCertificao.vue?vue&type=script&lang=js"
export * from "./BlocoListarAtivasCertificao.vue?vue&type=script&lang=js"
import style0 from "./BlocoListarAtivasCertificao.vue?vue&type=style&index=0&id=b1059244&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports